import Phaser from "phaser";
import { SHOT_LIFESPAN_MS } from "../config";
import type Pathogen from "./Pathogen";

/**
 * A small white-cell projectile. Flies toward its target enemy and, on arrival,
 * invokes the hit callback (the scene applies `power` damage). Self-destructs if
 * the target is gone or it lives too long.
 */
export default class Shot extends Phaser.GameObjects.Sprite {
  private target: Pathogen;
  private speed: number;
  private onHit: (t: Pathogen) => void;
  private bornAt: number;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    target: Pathogen,
    speed: number,
    onHit: (t: Pathogen) => void,
  ) {
    super(scene, x, y, "shot");
    this.target = target;
    this.speed = speed;
    this.onHit = onHit;
    this.bornAt = scene.time.now;
    scene.add.existing(this);
    this.setDepth(15);
  }

  preUpdate(time: number, delta: number): void {
    super.preUpdate(time, delta);

    if (!this.target.active || this.target.removed || time - this.bornAt > SHOT_LIFESPAN_MS) {
      this.destroy();
      return;
    }

    const dist = Phaser.Math.Distance.Between(this.x, this.y, this.target.x, this.target.y);
    if (dist <= this.target.def.radius + 6) {
      this.onHit(this.target);
      this.destroy();
      return;
    }

    const step = (this.speed * delta) / 1000;
    const angle = Phaser.Math.Angle.Between(this.x, this.y, this.target.x, this.target.y);
    this.x += Math.cos(angle) * step;
    this.y += Math.sin(angle) * step;
    this.rotation = angle;
  }
}
